module.exports = __webpack_public_path__ + "static/img/3.e074e93.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/zh/3.png
// module id = cMQR
// module chunks = 0